import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { FleetDataInterface } from "../../../../../redux/interfaces/fleet.interface";

const autoTypeStatuses = [
  {
    value: 1,
    label: "Local",
  },
  {
    value: 2,
    label: "Internod",
  },
];

const getAutoTypeStatusLabel = (value: number) => {
  const getAutoTypeLabel = autoTypeStatuses.find(
    (item) => item.value === value,
  );

  return getAutoTypeLabel?.label;
};

export const fleetTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. auto",
    value: "nrauto",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Marca",
    value: "marca",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Model",
    value: "model",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Tip auto",
    value: "tip_auto",
    minW: 125,
  },
];

export const getFleetTableData = (data: FleetDataInterface[]): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_auto,
      crudData: item,
      data: [
        {
          title: item.nrauto,
        },
        {
          title: item.marca,
        },
        {
          title: item.model,
        },
        {
          badges: [
            {
              badgeText: getAutoTypeStatusLabel(item.tip_auto),
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
